import React, { Component } from 'react';
import { Spin, Table, Input, Modal } from 'antd';
import { connect } from 'dva';
import { parse, stringify } from 'qs';
import FilesUpload from 'nbugs-files-upload';
import { router } from 'umi';

import Container from '@/components/Container';
import { getCurrentBreadCrumbs } from '@/utils/utils';
import { ENV } from '@/services/utils';

import styles from './index.less';

const { Search } = Input;

@connect(({ field }) => ({
  ...field,
}))
class FieldView extends Component {
  constructor(props) {
    super(props);

    const columns = [
      {
        title: '评价对象',
        dataIndex: 'name',
      },
      {
        title: '自评分数',
        dataIndex: 'selfScore',
      },
      {
        title: '网评分数',
        dataIndex: 'score'
      },
      {
        title: '自评报告',
        dataIndex: '',
        render: record => (
          <span className="table-action-box">
            <a
              className="table-action-edit"
              onClick={event => this.handleShowSelfReport({ record, event })}
            >
              查看
            </a>
          </span>
        )
      },
      {
        title: '操作',
        render: record => (
          <span className="table-action-box">
            <a
              className="table-action-edit"
              onClick={event => this.handleJump({ record, event })}
            >
              查看指标评分细则
            </a>
          </span>
        )
      }
    ]

    const { search } = window.location;
    const query = parse(search.split('?').pop());
    const { currentProjectId, currentProjectName, storekey } = query;

    const breadcrumb = getCurrentBreadCrumbs({
      currentUrl: {
        context: '实地督查',
        path: `/supervision/field${window.location.search}`,
      },
      isTop: false,
      storekey: storekey || 'supservisionProjectBreadcrumb',
    });

    this.state = {
      breadcrumb,
      columns,

      currentProjectId,
      currentProjectName,
      storekey,

      currentPage: 1,
      pageSize: 10,

      showAppendixModal: false,
      currentAppendix: null,
    }
  }

  componentDidMount() {
    this.getList();
  }

  getList = (name = null) => {
    const { dispatch } = this.props;
    const { currentProjectId ,currentPage, pageSize } = this.state;
    dispatch({
      type: 'field/fetchList',
      payload: {
        projectId: currentProjectId,
        page: currentPage,
        pageSize,
        name,
      },
    });
  }

  handleShowSelfReport = ({ record, event }) => {
    if(event) {
      event.stopPropagation();
    }
    const { appendix } = record;
    // 查看自评报告
    this.setState({
      showAppendixModal: true,
      currentAppendix: appendix,
    })
  }

  handleModal = () => {
    this.setState({
      showAppendixModal: false,
    })
  }

  handleChangeSize = (current, pageSize) => {
    this.setState({
      currentPage: current,
      pageSize,
    }, () => {
      this.getList();
    })
  }

  handleChangePagination = (page, pageSize, callback) => {
    this.setState(
      {
        currentPage: page,
        pageSize,
      },
      () => {
        if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
          callback();
        } else {
          this.getList();
        }
      }
    );
  }

  handleJump = ({ record, event }) => {
    if(event) {
      event.stopPropagation();
    }
    const { id } = record;
    const { currentProjectId, currentProjectName, storekey } = this.state;
    // 跳页面
    router.push(`/supervision/norm/field/tree?${stringify({
      currentProjectName,
      currentProjectId,
      targetOrgId: id,
      storekey
    })}`)
  }

  handleSearch = (val) => {
    const { pageSize } = this.state;
    // this.getList(val);
    if(!val && !val.trim().length) {
      this.handleChangePagination(1, pageSize, this.getList);
    } else {
      this.handleChangePagination(1, pageSize, () => this.getList(val));
    }
  }

  renderHeader = () => {
    return (
      <div className="header align-right">
        <Search style={{width: 300}} placeholder="请输入评价对象名称" onSearch={this.handleSearch} />
      </div>
    )
  }

  render() {
    const { breadcrumb, columns, currentPage, showAppendixModal, currentAppendix } = this.state;
    const { targetList, spinProps, totalElements } = this.props;
    const tableProps = {
      rowKey: 'id',
      columns,
      dataSource: targetList,
      pagination: {
        total: totalElements,
        showTotal: () => <span>{`共${totalElements}条`}</span>,
        showSizeChanger: true,
        showQuickJumper: true,
        current: currentPage,
        onChange: this.handleChangePagination,
        onShowSizeChange: this.handleChangeSize,
      },
    };

    return (
      <Container breDataSource={breadcrumb} breStates isBreVersion>
        <div className={styles.field}>
          <div className="container">
            <Spin {...spinProps}>
              {this.renderHeader()}
              <Table {...tableProps} />
            </Spin>
          </div>
          {showAppendixModal &&
            <Modal
              visible
              centered
              title="自评报告"
              onOk={this.handleModal}
              onCancel={this.handleModal}
            >
              <FilesUpload
                edit={1}
                type="pc"
                APIEnv={ENV}
                groupId={currentAppendix}
                previewUrl={`//${window.location.hostname}/v2/preview/file`}
              />
            </Modal>}
        </div>
      </Container>
    );
  }
}

export default FieldView;